module.exports = __webpack_public_path__ + "img/top_image_score.7bcd16cd.png";